import {
  ElementType,
  type DataProtectionElement,
  type FormElement,
  type FormInputElement,
  type SelectElement,
  type TextElement,
} from '../form-definition';

export const isInputElement = (
  element: FormElement | null,
): element is FormInputElement => !!element?.field;

export const isTextElement = (element: FormElement): element is TextElement =>
  element.type === ElementType.text;

export const isDataProtectionElement = (
  element: FormElement,
): element is DataProtectionElement =>
  element.type === ElementType.dataProtection;

export const isSelectElement = (
  element: FormElement | undefined,
): element is SelectElement => element?.type === ElementType.select;

export const isSingleSelectElement = (
  element: FormElement | undefined,
): element is SelectElement => isSelectElement(element) && !element?.meta.multi;
